import { render, staticRenderFns } from "./PenaltyDetail.vue?vue&type=template&id=ac267336&"
import script from "./PenaltyDetail.vue?vue&type=script&lang=js&"
export * from "./PenaltyDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports